import { ScrollText } from "lucide-react";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";

const KIND_COLOR = {
  slr: "var(--sea)",
  slr_loss: "var(--sea)",
  slr_held: "var(--ink-2)",
  slr_mangrove: "var(--deep-water)",
  catch_up: "var(--drop)",
  sabotage: "var(--danger)",
  repair_card: "var(--sea)",
  board_thief: "var(--ink-2)",
  relocated: "var(--ink-2)",
  water: "var(--ink-2)",
  debt_paid: "var(--sea)",
  income: "#9A6A12",
  bank: "var(--sea)",
};

// The game log (newest first) in a side drawer. Layout F: opened from the top-bar menu
// (trigger={false}); the old top-bar button stays available for other callers.
// PAY UPFRONT: an entry with `private_to` (a blind draw: "Ben drew Park blind and paid 2.")
// shows its `private_text` only to that player (`viewer`); online the server already did this.
export function logText(e, viewer) {
  return e.private_to && viewer && e.private_to === viewer ? e.private_text || e.text : e.text;
}

export default function GameLog({ entries, open, onOpenChange, trigger = true, viewer = null }) {
  const list = [...(entries || [])].reverse();
  return (
    <>
      {trigger && <button
        type="button"
        data-testid="open-game-log-btn"
        onClick={() => onOpenChange(true)}
        className="btn-ghost"
        title={`Game log · ${list.length} entries`}
      >
        <ScrollText size={16} strokeWidth={1.8} /> Log
        <span data-testid="game-log-count" style={{ color: "var(--ink-4)", fontSize: 13 }}>{list.length}</span>
      </button>}
      <Sheet open={open} onOpenChange={onOpenChange}>
        <SheetContent side="right" aria-describedby={undefined} data-testid="game-log-drawer" className="w-[360px] max-w-[360px] flex flex-col" style={{ background: "var(--surface)", borderLeft: "1px solid var(--line)" }}>
          <SheetHeader>
            <SheetTitle className="font-display text-xl text-[color:var(--ink)]">Game log</SheetTitle>
          </SheetHeader>
          <ol className="flex-1 overflow-y-auto min-h-0 space-y-2 text-[12px] leading-snug pr-1" data-testid="game-log-list">
            {list.length === 0 && <li className="text-[color:var(--ink-3)]">Nothing yet.</li>}
            {list.map((e, i) => (
              <li key={list.length - i} className="flex gap-2" data-testid={`game-log-entry-${list.length - 1 - i}`}>
                <span className="shrink-0 mt-1 w-2 h-2 rounded-full" style={{ background: KIND_COLOR[e.kind] || "var(--ink-3)" }} />
                <span>
                  <span className="font-bold text-[color:var(--ink-3)] mr-1">R{e.round}</span>
                  {logText(e, viewer)}
                </span>
              </li>
            ))}
          </ol>
        </SheetContent>
      </Sheet>
    </>
  );
}
